module.exports = __webpack_public_path__ + "static/Issuer_Comment _HSE_Finance-ca62b0f799c832435f7eefec77b62ed8.pdf";